module.exports = __webpack_public_path__ + "img/12.410f6af1.webp";